import { useAuthStore, adminTokenCookieName } from '~/store/auth';
import { safeRedirectPath } from '~/utils/safe-redirect';

const publicRoutes = ['/password-reset', '/invite', '/square-oauth/callback', '/a'];

function isPublicPath(path: string): boolean {
  return publicRoutes.some(route => path === route || path.startsWith(route + '/'));
}

export default defineNuxtRouteMiddleware(async to => {
  if (isPublicPath(to.path)) {
    return;
  }

  // Handle admin authentication
  const authStore = useAuthStore();
  const { authenticated } = storeToRefs(authStore);

  // The access token cookie expires with the access token. The refresh token outlives it,
  // so a missing access token cookie does not mean that the operator is signed out.
  if (authStore.shouldRefreshTokens()) {
    await authStore.refreshTokens();
  }

  const isAuthenticated = useCookie(adminTokenCookieName).value;
  if (isAuthenticated) {
    authenticated.value = true;
    await useAuthStore().refreshProfile();
  }

  // Redirect to the original path if authenticated
  if (isAuthenticated && to?.name === 'signin') {
    const redirectPath = safeRedirectPath(to.query.redirect);
    if (import.meta.client) {
      window.location.href = redirectPath;
    } else {
      return navigateTo(redirectPath);
    }
  }

  if (!isAuthenticated && to?.name !== 'signin') {
    return navigateTo({ path: '/signin', query: { redirect: to.fullPath } });
  }

  // utils/page-permission.ts lists the keys of each page.
  if (isAuthenticated && !authStore.canOpenPage(to.path)) {
    return navigateTo(authStore.landingPath());
  }
});
